export const SAVE = 'step8.SAVE';
export const VALUE_CHANGED = 'step8.VALUE_CHANGED';
export const LOAD = 'step8.VALUE_LOAD';
export const NEXT = 'step8.NEXT';
export const RESET = 'step8.RESET';
export const RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES = 'step8.RESET_OVERSEAS_EMERGENCY_MEDICAL_OR_DENTAL_EXPENSES';
export const RESET_ACCIDENTAL_DEATH = 'step8.RESET_ACCIDENTAL_DEATH';
export const RESET_LOSS_OF_INCOME = 'step8.RESET_LOSS_OF_INCOME';
export const RESET_CONTACT_EMERGENCY_ASSISTANCE = 'step8.RESET_CONTACT_EMERGENCY_ASSISTANCE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step8/constants.js